import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

export const profileService = {
  getUserInfo: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.account.profile.getUserInfo,
      payload,
      headers,
      hasErrorHandler,
    }),

  updateUserInfo: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.profile.updateUserInfo,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCommunicationPermission: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.account.profile.getCommunicationPermission,
      payload,
      headers,
      hasErrorHandler,
    }),

  updateCommunicationPreferences: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.profile.communicationPreferences,
      payload,
      headers,
      hasErrorHandler,
    }),

  cancelAccount: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.profile.cancelAccount,
      payload,
      headers,
      hasErrorHandler,
    }),
  changePassword: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.profile.changePassword,
      payload,
      headers,
      hasErrorHandler,
    }),
  verifyEmail: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.profile.verifyEmail,
      payload,
      headers,
      hasErrorHandler,
    }),
  sendSmsOTP: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.profile.sendSmsOTP,
      payload,
      headers,
      hasErrorHandler,
    }),
  verifySMSOTP: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.profile.verifySMSOTP,
      payload,
      headers,
      hasErrorHandler,
    }),
  sendEmailOTP: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.profile.sendEmailOTP,
      payload,
      headers,
      hasErrorHandler,
    }),
  verifyEmailOTP: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.profile.verifyEmailOTP,
      payload,
      headers,
      hasErrorHandler,
    }),
  sendForgotPasswordOTP: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.profile.sendForgotPasswordOTP,
      payload,
      headers,
      hasErrorHandler,
    }),
  verifyForgotPasswordOTP: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.profile.verifyForgotPasswordOTP,
      payload,
      headers,
      hasErrorHandler,
    }),
  resetPassword: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.profile.resetPassword,
      payload,
      headers,
      hasErrorHandler,
    }),
  verifyEmailToken: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.profile.verifyEmailToken,
      payload,
      headers,
      hasErrorHandler,
    }),
};
